/**
 * Converts a JSON object into `FormData`, allowing it to be used in `multipart/form-data` requests.
 *
 * @param payload An object where keys are strings and values can be of any type, representing the data to convert.
 * @returns A `FormData` instance populated with key-value pairs from the JSON object.
 *
 * @example
 * const payload = { name: "John", age: 30 };
 * const formData = jsonToFormData(payload);
 * // formData can now be used in a fetch request with multipart/form-data encoding.
 */
export const jsonToFormData = (payload: Record<string, any>): FormData => {
  const formData = new FormData();

  for (const key in payload) {
    formData.append(key, payload[key]);
  }
  return formData;
};
